import accounting from "accounting"

export const formatRate = (value, precision = 2) => {
  if (value || value === 0) {
    const formatted = accounting.formatNumber(value, precision, ",", ".")
    return `${formatted}%`
  }
  return "-"
}
